import { useState } from "react";
import { X, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";

export const TagEditor = ({ tags, onChange, testid = "proposal-tags" }) => {
  const [draft, setDraft] = useState("");
  const add = () => {
    const t = draft.trim();
    if (!t) return;
    onChange([...tags, t]);
    setDraft("");
  };
  const seen = {};
  return (
    <div data-testid={testid}>
      <div className="flex flex-wrap gap-1.5">
        {tags.map((t, i) => {
          const dupe = seen[t.toLowerCase()];
          seen[t.toLowerCase()] = true;
          const bad = t.length > 20 || dupe;
          return (
            <span key={`${t}-${i}`} data-testid={`${testid}-chip-${i}`}
              className={`group inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs ${bad ? "border-rose-300/35 bg-rose-400/10 text-rose-200" : "border-[#5EE6D0]/30 bg-[#5EE6D0]/[0.08] text-[#B8F5EA]"}`}>
              <input
                value={t}
                data-testid={`${testid}-input-${i}`}
                onChange={(e) => onChange(tags.map((x, j) => (j === i ? e.target.value : x)))}
                className="bg-transparent outline-none"
                style={{ width: `${Math.max(t.length, 3) + 1}ch` }}
              />
              <span className="font-mono text-[10px] opacity-60">{t.length}</span>
              <button type="button" onClick={() => onChange(tags.filter((_, j) => j !== i))} data-testid={`${testid}-remove-${i}`} className="opacity-60 hover:opacity-100">
                <X className="h-3 w-3" />
              </button>
            </span>
          );
        })}
      </div>
      <div className="mt-2 flex gap-2">
        <Input value={draft} onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add())}
          placeholder="Add a tag" className="h-8 text-sm" data-testid={`${testid}-add-input`} />
        <button type="button" onClick={add} data-testid={`${testid}-add-button`} className="rounded-full border px-3 text-xs hover:bg-secondary">
          <Plus className="h-3.5 w-3.5" />
        </button>
      </div>
      <p className={`mt-1 font-mono text-xs ${tags.length > 13 ? "text-destructive" : "text-muted-foreground"}`} data-testid={`${testid}-count`}>{tags.length}/13 tags</p>
    </div>
  );
};
